import {Component} from "@angular/core";

@Component({
  selector: "app-section-7",
  templateUrl: "./section7.component.html",
  styleUrls: ["./section7.component.scss"]
})
export class Section7Component {
  constructor() {

  }
}